














































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class CouponView extends Vue {
  public items: Common.Coupon[] = new Array(0);
  public params: Common.CouponQuery = new Common.CouponQuery();
  public exportQuery = new Common.ExportQuery('クーポン', this.params);
  public sortOptions: any = [{ value: 'lastUpdatedOn', text: '最終更新日' },{ value: 'couponFlag', text: 'クーポン種別' },{ value: 'expiry', text: '有効期限' },];
  public created(){
    this.params.couponState = Common.CouponState.Usable;
  }
  public async onCreate(obj: Common.Coupon) {
    const workflows = this.$api.formatter.getOptions('workflow_approval');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }  
  public isNotPosted(item:Common.Coupon){
    if(!item) return true;
    if(item.state == Common.ApprovalStatus.NotApproved) return true;
    return false;
  }
  public isDiscount(item:Common.Coupon){
    return (item.couponFlag & (Common.CouponFlags.Discount | Common.CouponFlags.SafeIntroductionDiscount)) != 0;
  }
}
